import { Terms } from "../../types/terms";

const terms: Partial<Terms> = {
  units: {
    metres: "meters",
  },
};

export default terms;
